<template>
  <div>
    <Layout
      username="Supervisor"
      current-page="Reports"
      link-to-edit="/sup-dashboard/edit-profile"
    >
      <template slot="menuItems">
        <li
          v-for="{ title, icon, path } in menu"
          :key="title"
          class="nav-item"
        >
          <MenuItems
            :menu-item="title"
            :icon-menu="icon"
            :to-where="path"
          />
        </li>
      </template>
      <template slot="side info">
        <generate-excel :url="generatorUrl" name="supervisor" />
      </template>
      <template slot="content">
        <div class="jumbotron">
          <div class="my-3">
            Total: {{ sales.count }}
          </div>
          <div class="row justify-content-between mb-3">
            <div class="col-4">
              <form>
                <input
                  id="inlineFormInputName2"
                  v-model="searchQuery"
                  type="text"
                  class="form-control mb-2 mr-sm-2"
                  placeholder="Type to search..."
                  @input="onQueryChange"
                >
              </form>
            </div>
            <div class="col-5">
              <filitable-selector
                :data="agents"
                :handle-select="onAgentSelect"
                placeholder="Select agent"
              />
            </div>
          </div>
          <sales-table :data="sales.data" />
          <pagination
            :pages="sales.pages"
            :on-paginate="onPaginate"
            :current-page="currentPage"
          />
        </div>
      </template>
    </Layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Layout from "../../components/Layout";
import MenuItems from "../../components/MenuItems";
import SalesTable from "../../components/Tables/SalesTable.vue";
import Pagination from "../../components/Pagination.vue";
import FilitableSelector from "../../components/FilitableSelector";
import GenerateExcel from "../../components/GenerateSalesExcel";
export default {
  name: "Adminreports",
  components: {
    Layout,
    MenuItems,
    SalesTable,
    Pagination,
    FilitableSelector,
    GenerateExcel,
  },
  data() {
    return {
      menu: [
        {
          title: "Dashboard",
          icon: "fa fa-chart-line",
          path: "/supervisor",
        },
        {
          title: "Add Sales Agent",
          icon: "fa fa-plus",
          path: "/supervisor/agents/new",
        },
        {
          title: "Sales",
          icon: "fa fa-table",
          path: "/supervisor/sales",
        },
        {
          title: "Agents",
          icon: "fa fa-users",
          path: "/supervisor/agents",
        },
      ],
      searchQuery: "",
      agentId: null,
      timer: null,
      currentPage: 1,
    };
  },

  computed: {
    ...mapGetters({
      sales: "sales/companySales",
      agents: "agent/companyUsers",
      currentUser: "auth/currentUser",
    }),
    generatorUrl() {
      const { companyId } = this.currentUser;
      const { VUE_APP_SERVER_BASE_URL: BASE_URL } = process.env;
      const { count } = this.sales;
      let url = `${BASE_URL}/companies/${companyId}/sales?page=1&limit=${count}`;
      if (this.searchQuery) {
        url += `&search=${this.searchQuery}`;
      }
      if (this.agentId) {
        url += `&agentId=${this.agentId}`;
      }
      return url;
    },
  },
  beforeCreate() {
    this.$store.dispatch("agent/getCompanyAgents");
    this.$store.dispatch("sales/fetchCompanySales");
  },
  methods: {
    onQueryChange() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.$store.dispatch("sales/fetchCompanySales", {
          search: this.searchQuery,
          agentId: this.agentId,
        });
      }, 500);
    },
    onPaginate(value) {
      if (value > 0 && value < this.sales.pages + 1) {
        this.currentPage = value;
        this.$store.dispatch("sales/fetchCompanySales", {
          search: this.searchQuery,
          page: this.currentPage,
        });
      }
    },
    onAgentSelect(value) {
      this.agentId = value;
      this.$store.dispatch("sales/fetchCompanySales", {
        search: this.searchQuery,
        agentId: value,
      });
    },
  },
};
</script>
<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}
.jumbotron {
  overflow-x: scroll;
}
</style>
